export const percentage = (count: any, totalCount: number) => {
    return Math.round((count / totalCount) * 100)
};